import { defineComponent as R, useSlots as T, ref as d, computed as k, watch as D, onBeforeUnmount as V, createElementBlock as f, createCommentVNode as i, openBlock as n, withKeys as A, normalizeClass as r, createVNode as x, createElementVNode as g, withModifiers as L, unref as w, createBlock as j, renderSlot as m, toDisplayString as K, withCtx as F } from "vue";
import q from "lodash-es/uniqueId";
import { FOCUS_ELEMENTS_SELECTOR as P } from "./constants.js";
import { t as H } from "./locale.js";
import U from "./Backdrop.js";
import I from "./Button.js";
import N from "./Icon.js";
import { _ as W } from "./_plugin-vue_export-helper-CHgC5LLL.js";
var G = /* @__PURE__ */ ((l) => (l.Narrow = "narrow", l.Medium = "medium", l.Wide = "wide", l))(G || {}), J = /* @__PURE__ */ ((l) => (l.Center = "center", l.Left = "left", l.Right = "right", l))(J || {});
const Q = ["aria-labelledby"], X = { class: "tw-flex tw-place-items-center" }, Y = ["id"], Z = { class: "stash-modal__footer__actions tw-flex tw-flex-col tw-justify-end lg:tw-flex-row" }, ee = /* @__PURE__ */ R({
  name: "ll-modal",
  __name: "Modal",
  props: {
    hideClose: { type: Boolean, default: !1 },
    open: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    modelValue: { type: Boolean, default: !1 },
    size: { default: "medium" },
    scrollable: { type: Boolean, default: !1 },
    contrast: { type: Boolean, default: !1 },
    title: { default: "" },
    disableBodyPadding: { type: Boolean },
    position: { default: "center" },
    hideHeader: { type: Boolean, default: !1 },
    closeButtonColorClass: { default: "tw-text-white/50" },
    preventDismiss: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "update:is-open", "dismiss"],
  setup(l, { emit: M }) {
    const e = l, y = M, _ = T(), u = d(), B = d(), h = d([]), b = d(), E = d(), c = d({ height: "", overflow: "" }), C = q("modal-header-"), z = k(() => !!_.actions || !!_.footer), o = k(() => e.open || e.isOpen), s = k(() => e.position === "left" || e.position === "right");
    function p() {
      return document.scrollingElement || document.body;
    }
    D(
      o,
      () => {
        S(o.value ? "hide" : "show"), o.value && Object.assign(c.value, {
          height: p().style.height,
          overflow: p().style.overflow
        }), Object.assign(p().style, {
          overflow: o.value ? "hidden" : c.value.overflow,
          // Prevents page from scrolling when modal is open
          height: o.value ? "100%" : c.value.height
          // Ensures the backdrop covers the entire page when modal is open; see https://github.com/LeafLink/stash/pull/713#issuecomment-1184602535
        });
      },
      { immediate: !0 }
    ), V(() => {
      var t;
      S("show"), Object.assign(p().style, {
        overflow: c.value.overflow,
        height: c.value.height
      }), document.removeEventListener("keydown", O), (t = B.value) == null || t.focus();
    });
    function v() {
      e.preventDismiss || (y("update:open", !1), y("update:is-open", !1), y("dismiss"));
    }
    D(u, () => {
      u.value && (B.value = document.activeElement, u.value.focus(), h.value = Array.from(u.value.querySelectorAll(P)), b.value = h.value[0], E.value = h.value[h.value.length - 1], document.addEventListener("keydown", O));
    });
    function O(t) {
      var a, $;
      t.key === "Tab" && (t.shiftKey && document.activeElement === b.value ? ((a = E.value) == null || a.focus(), t.preventDefault()) : document.activeElement === E.value && (($ = b.value) == null || $.focus(), t.preventDefault()));
    }
    function S(t) {
      const a = document.getElementById("launcher");
      !a || !a.parentElement || (a.parentElement.style.display = t === "show" ? "block" : "none");
    }
    return (t, a) => o.value ? (n(), f("div", {
      key: 0,
      ref_key: "rootRef",
      ref: u,
      class: r(["stash-modal tw-fixed tw-inset-0", {
        "tw-invisible tw-z-behind": !o.value,
        "tw-visible tw-z-modal": o.value,
        "lg:tw-flex lg:tw-flex-col lg:tw-items-center lg:tw-justify-center": e.position === "center",
        "tw-overflow-y-auto": !e.scrollable && !s.value,
        "tw-overflow-y-hidden": s.value
      }]),
      "data-test": "ll-modal",
      tabindex: "0",
      onKeydown: A(v, ["esc"])
    }, [
      x(U, {
        class: "stash-modal__backdrop",
        onClick: L(v, ["stop"])
      }),
      g("div", {
        "aria-modal": "true",
        role: "dialog",
        "aria-labelledby": w(C),
        class: r(["stash-modal__dialog tw-relative tw-flex tw-h-screen tw-w-full tw-flex-col lg:tw-shadow-3xl", [
          `stash-modal__dialog--size-${e.size}`,
          `stash-modal__dialog--position-${e.position}`,
          {
            "stash-modal__dialog--is-open": o.value,
            "stash-modal__dialog--is-drawer": s.value,
            "stash-modal__dialog--is-contrast": e.contrast,
            "stash-modal__dialog--is-scrollable": e.scrollable,
            "lg:tw-w-[360px]": e.size === "narrow",
            "lg:tw-w-[648px]": e.size === "medium",
            "lg:tw-w-[960px]": e.size === "wide",
            "lg:tw-my-0 lg:tw-h-auto lg:tw-max-h-[90vh]": e.position === "center",
            // tw-absolute causing this to break when items in bottom of container get focus
            "lg:tw-fixed lg:tw-h-screen": s.value,
            "lg:tw-left-0": e.position === "left",
            "lg:tw-right-0": e.position === "right"
          }
        ]]),
        onClick: a[0] || (a[0] = L(() => {
        }, ["stop"]))
      }, [
        e.hideHeader ? i("", !0) : (n(), f("header", {
          key: 0,
          "data-test": "stash-modal__header",
          class: r(["stash-modal__header tw-grid tw-h-12 tw-place-items-center tw-bg-purple-500", { "lg:tw-rounded-t": !s.value }])
        }, [
          g("div", X, [
            m(t.$slots, "headerAction", {}, void 0, !0)
          ]),
          e.title ? (n(), f("h3", {
            key: 0,
            id: w(C),
            class: "tw-m-0 tw-flex-1 tw-leading-6 tw-text-white"
          }, K(e.title), 9, Y)) : i("", !0),
          e.hideClose ? i("", !0) : (n(), j(I, {
            key: 1,
            icon: "",
            "data-test": "ll-modal-close",
            title: w(H)("ll.closeModal"),
            type: "button",
            onClick: v
          }, {
            default: F(() => [
              x(N, {
                class: "tw-text-white",
                name: "close"
              })
            ]),
            _: 1
          }, 8, ["title"]))
        ], 2)),
        !e.hideClose && e.hideHeader ? (n(), j(I, {
          key: 1,
          class: "tw-absolute tw-right-0 tw-top-0 tw-z-10",
          icon: "",
          "data-test": "ll-modal-close",
          type: "button",
          title: w(H)("ll.closeModal"),
          onClick: v
        }, {
          default: F(() => [
            x(N, {
              class: r(["tw-drop-shadow-md", [e.closeButtonColorClass]]),
              name: "close"
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["title"])) : i("", !0),
        w(_)["featured-content"] ? (n(), f("div", {
          key: 2,
          class: r(["stash-modal__featured-content tw-relative", {
            "tw-rounded-t": e.hideHeader
          }])
        }, [
          m(t.$slots, "featured-content", {}, void 0, !0)
        ], 2)) : i("", !0),
        g("div", {
          class: r(["stash-modal__body tw-flex-1 tw-overflow-y-auto", [
            {
              "tw-p-3 lg:tw-p-6": !e.disableBodyPadding,
              "lg:tw-overflow-y-visible": !e.scrollable && !s.value,
              "lg:tw-rounded-b": !z.value && !s.value,
              "tw-bg-white": !e.contrast,
              "tw-bg-ice-200": e.contrast
            }
          ]]),
          "data-test": "stash-modal__body"
        }, [
          m(t.$slots, "default", {}, void 0, !0)
        ], 2),
        z.value ? (n(), f("footer", {
          key: 3,
          class: r(["stash-modal__footer tw-border-t tw-border-ice-500 tw-bg-ice-100 tw-p-3 lg:tw-p-6", { "lg:tw-rounded-b": !s.value }])
        }, [
          m(t.$slots, "footer", {}, () => [
            g("div", Z, [
              m(t.$slots, "actions", {}, void 0, !0)
            ])
          ], !0)
        ], 2)) : i("", !0)
      ], 10, Q)
    ], 34)) : i("", !0);
  }
}), de = /* @__PURE__ */ W(ee, [["__scopeId", "data-v-fb435673"]]);
export {
  J as ModalPosition,
  G as ModalSize,
  de as default
};
//# sourceMappingURL=Modal.js.map
